import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AppShell from "@/components/AppShell";
import PinGate from "@/components/PinGate";
import Dashboard from "@/pages/Dashboard";
import Roadmap from "@/pages/Roadmap";
import Assistant from "@/pages/Assistant";
import Journal from "@/pages/Journal";

function App() {
  return (
    <div className="App">
      <PinGate>
        <BrowserRouter>
          <Routes>
            <Route element={<AppShell />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/roadmap" element={<Roadmap />} />
              <Route path="/assistant" element={<Assistant />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </PinGate>
      <Toaster theme="dark" richColors position="top-right" />
    </div>
  );
}

export default App;
